import React from "react";

const BreadCrumbBanner = ({ title, backgroundImage }) => {
  return (
    <>
      <section
        className="about-hero"
        style={{
          backgroundImage: `url(${backgroundImage})`,
        }}
      >
        <div className="overlay">
          <h1>{title}</h1>
        </div>
      </section>
    </>
  );
};

export default BreadCrumbBanner;
